/***
 * @file:ä¸è½½æå¡
 * @author: linkun.he
 * @Date: 2021-10-21 16:07:13
 */
import { Injectable } from '@angular/core';
import { StoreService } from './store.service';

@Injectable({
  providedIn: 'root',
})
export class DownloadService {
  constructor(public storeSrv: StoreService) {}

  downloadByPostJson(path: string, param, name: string, method = 'POST', contentTpe = 'application/json') {
    const token = this.storeSrv.get('token', true);
    const body = JSON.stringify(param);
    fetch(path, {
      headers: {
        Authorization: `Bearer ${token}`,
        'content-type': contentTpe,
      },
      method,
      body,
    }).then((response: any) => {
      response.blob().then((data) => {
        const node = window.document.createElement('a');
        const href = window.URL.createObjectURL(data);
        node.setAttribute('href', href);
        node.setAttribute('download', name);
        node.style.visibility = 'hidden';
        document.body.appendChild(node);
        node.click();
        document.body.removeChild(node);
        // å»¶æ¶éæ¾
        setTimeout(() => {
          URL.revokeObjectURL(data); // ç¨URL.revokeObjectURL()æ¥éæ¾è¿ä¸ªobject URL
        }, 100);
      });
    });
  }
}
